import React from 'react';
import { PropTypes } from 'prop-types';
import { menuBlockResize } from '../Common/Helper';
import { Link } from 'react-router';

const NavItemDesktopText = props => (
  <div className='mmd__column-text'
    style={{ maxHeight: `${menuBlockResize(props.height, props.rowSize)}` }}>
    <div className='mmd__header'>{props.headerLabel}</div>
    <div className='mmd__content'>
      {props.menuSubitems &&
        <ul>
          {props.menuSubitems.map((subitem, index) =>
            (
              <li key={index}>
                <a
                  href={props.tRoute(subitem.href)}
                  to={subitem.href}
                  id={subitem.label == 'Layflat' ? 'layflatNavbarLink' : null }
                >
                  {subitem.label}
                </a>
              </li>
            ))}
        </ul>
      }
    </div>
    <div className='mmd__footer'>
      <a href={props.tRoute(props.footerHref)}>
        {props.footerLabel}
      </a>
    </div>
  </div>
);

NavItemDesktopText.propTypes = {
  headerLabel: PropTypes.string,
  footerLabel: PropTypes.string,
  headerHref: PropTypes.string,
  footerHref: PropTypes.string,
  menuSubitems: PropTypes.arrayOf(PropTypes.shape({
    href: PropTypes.string,
    label: PropTypes.string,
  })),
};

export default NavItemDesktopText;



// WEBPACK FOOTER //
// ./src/Nav/NavItemDesktopText.js